import { HtmlEntities } from '../constants/html-entities'

const { MDASH, NDASH } = HtmlEntities

/**
 * Returns a string representation of the vehicle number and vehicle name like this: [Number] – [Name]
 *
 * @param {VehicleObject} vehicle - A single vehicle object
 * @param {string} [fallback=MDASH] - Value to be used if name could not be parsed
 * @returns {string} The returned string
 */
export function formatVehicleName(vehicle, fallback = MDASH) {
    if (!vehicle || (!vehicle.name && !vehicle.number)) {
        return fallback
    }

    const { name, number } = vehicle

    if (name && number) {
        return `${number} ${NDASH} ${name}`
    }
    if (name) {
        return name
    }
    if (number) {
        return number
    }

    return fallback
}
